// EWM-224 — global minimum order value.
//
// Below this value, the Workato 'jfs' freight service adds a small-order surcharge
// to the shipping cost. Per Luke (2026-07-07): the freight service OWNS that
// calculation — the site does NOT compute the surcharge. This value is the
// site-side threshold used ONLY to decide when to show the informational,
// non-blocking warning banner on the cart + checkout; keep it in sync with the
// threshold the freight service uses.
//
// It's a variable — overridable per environment via
// NEXT_PUBLIC_MIN_ORDER_THRESHOLD_CENTS (minor units, 5000 = $50.00) — so the value
// can change without a code release. Separating the surcharge out as its own
// Order Summary line item is deferred to Phase 2.
const DEFAULT_MIN_ORDER_THRESHOLD_CENTS = 5000;

export const MIN_ORDER_THRESHOLD_CENTS =
  Number(process.env.NEXT_PUBLIC_MIN_ORDER_THRESHOLD_CENTS) || DEFAULT_MIN_ORDER_THRESHOLD_CENTS;
